import React from "react";
interface props {
  heading: string;
  textContent?: string;
  icon?: React.ReactNode;
}

export const AboutUsCard = ({ heading, textContent, icon }: props) => {
  return (
    <>
      {" "}
      <div className="flex justify-between lg:pl-8 lg:pt-7 lg:pb-8 lg:pr-11 lg:clip-path-searchWebPolygon lg:bg-[#F8F8F8]">
        <div className="">
          <p className="font-openSans font-normal text-mobile-subheading leading-6 text-brand-textBlack">
            {heading}
          </p>
          <p className="mt-5 font-openSans font-normal text-mobile-body-sm leading-4 text-brand-textGrey">
            {textContent}
          </p>
        </div>
        <div className="flex flex-col justify-end ml-5 lg:ml-8">
          <div className="w-[78px] h-20 clip-path-bottomLeftAboutUs p-4 bg-[#F8F8F8]">
            {icon}
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUsCard;
